import { MigrationSpec } from "../migration.models"

const csatReportMetricTemplates: MigrationSpec = {
  type: "SEED_CSAT_REPORT_METRIC_TEMPLATES",
  collection: "ReportWidgetMetricTemplates",
  risk: "SAFE",
  title: {
    en: "CSAT → report metric templates",
    tr: "CSAT → rapor metrik şablonları"
  },
  description: {
    en:
      "Inserts the six `csat` (live chat CSAT) report metric templates when missing: sent " +
      "(`csat_sent`), responses (`csat_responded`), response rate (`csat_response_rate`), " +
      "CSAT score (`csat_average_score`), satisfaction rate (`csat_satisfaction_rate`) and " +
      "comments (`csat_comments`). Written with `$setOnInsert`, so a second run changes " +
      "nothing and existing (possibly edited) templates are never overwritten.",
    tr:
      "Eksikse altı `csat` (canlı destek CSAT) rapor metrik şablonunu ekler: gönderilen " +
      "(`csat_sent`), yanıtlanan (`csat_responded`), yanıt oranı (`csat_response_rate`), " +
      "CSAT puanı (`csat_average_score`), memnuniyet oranı (`csat_satisfaction_rate`) ve " +
      "yorumlar (`csat_comments`). `$setOnInsert` ile yazılır: ikinci çalıştırma hiçbir şey " +
      "değiştirmez, mevcut (düzenlenmiş olabilecek) şablonların üzerine asla yazılmaz."
  },
  expectedDocuments: {
    filter: {
      dataSource: "csat",
      metricType: {
        $in: [
          "csat_sent",
          "csat_responded",
          "csat_response_rate",
          "csat_average_score",
          "csat_satisfaction_rate",
          "csat_comments"
        ]
      }
    },
    count: 6
  },
  notes: [
    {
      en:
        "Run before “CSAT → report widget templates”: those widgets reference these metric " +
        "templates.",
      tr:
        "“CSAT → rapor widget şablonları”ndan önce çalıştırın: o widget'lar bu metrik " +
        "şablonlarına referans verir."
    }
  ]
}

export default csatReportMetricTemplates
